import { Theme } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ palette, spacing, typography }: Theme) {
    // TODO: use styledBy to better allow for styling card background and text colors
    const userColor = palette.augmentColor({ main: palette.background.default });
    const userColorLight = palette.augmentColor({ main: userColor.light });

    return {
        root: {
            height: '100%',
        },
        userCard: {
            wordWrap: 'break-word' as const,
            margin: spacing(1),
            backgroundColor: userColorLight.main,
            color: userColorLight.contrastText,
        },
        ivaCardContent: {
            '&:last-child': {
                padding: spacing(2),
            },
        },
        userCardBody: {},
    };
}